const PhotoCheckRequest = require('./photo_check_request.js');

const warningTypeName = 'guitars';
const route = 'bass';
const responseAttribute = 'base_body';

module.exports = class BassGuitarsPhotoContents {
  static get productTypeUUID() {
    return '53a9c7d7-d73d-4e7f-905c-553503e50a90';
  }

  constructor(photo, imageDetectionPath) {
    this.photo = photo;
    this.imageDetectionPath = imageDetectionPath;
  }

  checkPhoto() {
    return new PhotoCheckRequest(
      this.photo, 
      this.imageDetectionPath, 
      route, 
      responseAttribute, 
      warningTypeName).checkPhoto();
  }
};



// WEBPACK FOOTER //
// ./javascripts/components/photos/contents/bass_guitars.js